import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html';

function convertToHtml(delta) {
    let ops = null;

    try {
        let deltaVal = JSON.parse(delta);
        if (deltaVal.ops) {
            ops = deltaVal.ops;
        }
    } catch {
        // do nothing. Just ignore this. The data was rubbish
    }

    if (ops) {
        let converter = new QuillDeltaToHtmlConverter(ops, {});
        return converter.convert();
    } else {
        return `<p>N/A</p>`;
    }
}

export {
    convertToHtml
}